import { createFileRoute } from "@tanstack/react-router";
import { Services } from "src/components/homepage/services/services";
import { HeroSection } from "src/components/homepage/hero-section/hero-section";
import { References } from "src/components/homepage/references/references";
import { Contacts } from "src/components/homepage/contacts/contacts";
import { InProgress } from "src/components/homepage/in-progress/in-progress";
import {
  homepageQueryOptions,
  inProgressReferencesQueryOptions,
  referencesOnHomepageQueryOptions,
} from "~/react-query/react-query";

export const Route = createFileRoute("/")({
  component: Home,
  loader: async ({ context }) => {
    const [homepage, references, inProgressReferences] = await Promise.all([
      context.queryClient.ensureQueryData(homepageQueryOptions()),
      context.queryClient.ensureQueryData(referencesOnHomepageQueryOptions()),
      context.queryClient.ensureQueryData(inProgressReferencesQueryOptions()),
    ]);
    return { homepage, references, inProgressReferences };
  },
});

function Home() {
  const { homepage, references, inProgressReferences } = Route.useLoaderData();

  if (!homepage) {
    return <div>data nebyla nalezena</div>;
  }

  return (
    <div
      className={
        "-top-navbar-height container mx-auto overflow-x-hidden px-2 lg:overflow-x-visible"
      }
    >
      <HeroSection hero_photos={homepage.hero_photos} />
      {references && references.length > 0 && (
        <References
          references={references}
          title={homepage.references_title ?? "Reference"}
        />
      )}
      {inProgressReferences && inProgressReferences.length > 0 && (
        <InProgress
          references={inProgressReferences}
          title={homepage?.in_progress_title ?? "Právě realizujeme"}
        />
      )}
      <Services
        services={homepage?.services}
        servicesTitle={homepage?.services_title}
      />
      <Contacts
        socialLinks={homepage?.social_links ?? []}
        title={homepage?.contacts_title ?? "Kontakty"}
        contacts={homepage?.contacts ?? []}
      />
    </div>
  );
}
